import React, { useRef, useState } from "react";
import { Grid } from "@mui/material";
import { FormButton, SpinnerOverlay } from "components";
import { FormikSelectInput, FormikTextInput } from "components/UI/Inputs/FormikInputs";
import { Form, Formik } from "formik";
import * as yup from "yup";
import { LARGO, mensajeLargo } from "consts/limites-campos";
import { useRecoilValue, useSetRecoilState } from "recoil";
import {
    snackbarData,
    userCredentials,
} from "recoilState/GlobalState";
import styles from "styles/pages/ModalActions.module.scss";
import { RNHNivelIns } from "services/services-mia/programa-salud/estructuras/RNHNivelIns";
import { COMPONENTES_MAXIMOS } from "../componentesMaximos";

export default function InsertModal({ updateList, closeModal }) {
    const setSnackBarInfo = useSetRecoilState(snackbarData);
    const credentials = useRecoilValue(userCredentials);
    const [inRequest, setInRequest] = useState(false);
    const formikRef = useRef();

    const handleCreateNivel = async (values) => {
        const response = await RNHNivelIns(
            credentials,
            {
                name: values.nombre,
                cod: values.cod,
                maxLevel: values.maxLevel
            }
        );
        if (response.ok) {
            setSnackBarInfo({
                message: "Nivel creado correctamente",
                severity: "success",
                open: true,
            });
            formikRef.current.resetForm();
            updateList();
            closeModal();
        }
    }
    return (
        <Formik
            innerRef={formikRef}
            initialValues={{
                nombre: "",
                cod: "",
                maxLevel: "",
            }}
            validationSchema={
                yup.object({
                    nombre: yup.string("Debe ingresar un nombre").max(LARGO.nombre, mensajeLargo(LARGO.nombre)).required("Debe ingresar un nombre"),
                    cod: yup.string("Debe ingresar un código").max(LARGO.cod, mensajeLargo(LARGO.cod)).required("Debe ingresar un código"),
                    maxLevel: yup.string().oneOf(COMPONENTES_MAXIMOS.map(({ cod }) => cod)).required("Debe seleccionar una jerarquía máxima"),
                })
            }
            onSubmit={(values) => {
                handleCreateNivel(values);
            }}
        >
            <Form className={styles.inputs} noValidate>
                <div className={styles["column"]}>
                    <Grid
                      container
                      rowSpacing={0}
                      columnSpacing={2}
                      sx={{
                        width: "100%",
                        "& .MuiFormControl-root": { marginTop: 0, marginBottom: 0 },
                      }}
                    >
                      <Grid item xs={12}>
                        <FormikTextInput
                            fullWidth={true}
                            name="nombre"
                            labelText="Nombre"
                            inputProps={{ maxLength: LARGO.nombre }}
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <FormikTextInput
                            fullWidth={true}
                            name="cod"
                            labelText="Código"
                            inputProps={{ maxLength: LARGO.cod }}
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <FormikSelectInput
                            fullWidth={true}
                            name="maxLevel"
                            labelText="Jerarquía Máxima"
                        >
                            <option value="" disabled>
                                Seleccione
                            </option>
                            {COMPONENTES_MAXIMOS.map(({ cod, label }) => (
                                <option key={cod} value={cod}>
                                    {label}
                                </option>
                            ))}
                        </FormikSelectInput>
                      </Grid>
                    </Grid>
                    <FormButton
                        inRequest={inRequest}
                        newFormData={{ button: "Crear" }}
                        onCloseModal={closeModal}
                    />
                    {(inRequest) && <SpinnerOverlay />}
                </div>
            </Form>
        </Formik>
    );
}
